import { useState, useEffect } from 'react';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { configurePurchases } from 'utils/revenueCat';
import { useEvieOnboardingContext } from '../EvieOnboardingProvider';
import { KEYS, IDENTIFIERS } from './constants';
import { useGetParams } from './useGetParams';

export const getOfferIdentifier = ({ currentCountry, urlIdentifier, identifiers }) => {
  // actualizar para que traiga las ofertas con el nuevo identifier
  if (urlIdentifier) return urlIdentifier;
  if (currentCountry === 'US') return identifiers.US;
  return identifiers.FULL;
};

export const useOfferings = (userId) => {
  const { identifier } = useGetParams();

  const { country } = useEvieOnboardingContext();

  const [selectedId] = useLocalStorage(KEYS.USER_ID);
  const [discountIdentifier, setDiscountIdentifier] = useLocalStorage(KEYS.IDENTIFIER);

  const [isFetchingOfferings, setIsFetchingOfferings] = useState(false);

  const currentIdentifier = identifier || discountIdentifier;

  const isDiscount = [
    IDENTIFIERS.THIRTY,
    IDENTIFIERS.FIFTY,
    IDENTIFIERS.US_DISCOUNT,
    IDENTIFIERS.TWENTY,
    IDENTIFIERS.PELVIC,
  ].includes(currentIdentifier);

  const [offeringList, setOfferingList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    setDiscountIdentifier(identifier);
  }, [identifier, setDiscountIdentifier]);

  useEffect(() => {
    const fetchOfferings = async () => {
      const offerIdentifier = getOfferIdentifier({
        currentCountry: country,
        urlIdentifier: currentIdentifier,
        identifiers: IDENTIFIERS,
      });

      try {
        setIsFetchingOfferings(true);
        const offerings = await configurePurchases(userId || selectedId).getOfferings();
        if (offerings.all[offerIdentifier].availablePackages.length !== 0) {
          setOfferingList(offerings.all[offerIdentifier].availablePackages);
        }
      } catch (error) {
        console.error('Error fetching offerings: ', error);
      } finally {
        setIsFetchingOfferings(false);
      }
    };
    if (userId || selectedId) {
      fetchOfferings();
    }
  }, [userId, selectedId, country, currentIdentifier]);

  useEffect(() => {
    if (offeringList.length > 0) {
      const findYearlyOffer = offeringList.find((offer) => offer.identifier === '$rc_annual');
      setSelectedOffer(findYearlyOffer);
    }
  }, [offeringList]);

  return {
    offeringList,
    selectedOffer,
    setSelectedOffer,
    isDiscount,
    currentIdentifier,
    isFetchingOfferings,
  };
};
